import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import storage from "../../Assets/js/Global";
import { GlobalContext } from "../../Context/GlobalContext";
import { images } from "../../Assets/images";
import { Languages } from "lucide-react";

const LanguageSelector = () => {
  const {
    setSelected,
    selected,
    setIsManualChange,
    translatedLabels,
    languages,
    getLanguageList,
    logoUrl,
  } = useContext(GlobalContext);
  const authLabel = translatedLabels?.auth;
  let location = useLocation();
  let pathname = location.pathname;
  let isLanguagePage = pathname === "/language-selection"

  const isLoggedIn = storage.get("isLoggedIn");
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    storage.set("selectedLanguage", selected);
    setSelected(selected);
  }, [selected, setSelected]);
  useEffect(() => {
    const timer = setTimeout(() => setShowSplash(false), 3000);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    getLanguageList();
  }, [getLanguageList]);

  const companyId = process.env.REACT_APP_COMPANY_ID;
  if (showSplash && !isLoggedIn && companyId === "8nn29") {
    return (
      <div className="splash-screen">
        <div className="splash-overlay"></div>
        <img
          src={images.initialLogo}
          alt="App Logo"
          className="splash-logo"
        />
      </div>
    );
  }
  return (
    <div className='container'>
      <div className='header-container pt-5'>
        <div className="d-flex justify-content-center">
          {!isLoggedIn && (
            <div className="app-logo">
              <img
                src={logoUrl || images.appLogo}
                alt="app-logo"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = images.appLogo;
                }}
              />
            </div>
          )}
        </div>

        <h4 className="fw-semibold mt-4 mb-4 d-flex align-items-center gap-2">
          <Languages color="#11A8DF" size={30} />
          <span className="mb-0 fw-semibold">
            {authLabel?.choose_your_language?.label_value ||
              "Choose your language"}
          </span>
        </h4>
      </div>

      <div className="mb-4">
        {languages?.map((lang, index) => (
          <div
            key={index}
            className={`card language-card shadow-sm ${selected === lang.language_code ? "border-primary bg-light" : ""
              }`}
            onClick={() => {
              setSelected(lang.language_code);
              setIsManualChange(true);
            }}
            style={{ cursor: "pointer", position: "relative" }}
          >
            <div className="card-body d-flex justify-content-between align-items-center">
              <div>
                <p className="language-name">{lang.language_translate}</p>
                <p className="mb-0 text-muted" style={{ fontSize: "14px" }}>
                  {lang.language_name}
                </p>
              </div>
              {selected === lang.language_code && (
                <img src={images.checkIcon} alt="check-icon" />
              )}
            </div>
          </div>
        ))}
      </div>

      {selected && (
        <div className={`continue-btn ${!isLanguagePage ? "bottom-padding" : ""}`}>
          <Link
            to={isLoggedIn ? "/profile" : "/login"}
            className="btn btn-primary"
          >
            {authLabel?.continue?.label_value || "Continue"}
          </Link>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
